// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2WB_V","right":"styles_right__1KV3P"};